<template>
    <v-tabs
        v-model="mobileTabs"
        :stacked="isMobile"
        density="compact"
        grow
        class="mob-search-tabs sticky-bar"
        color="primary"
    >
        <v-tab v-for="tab in tabs" :key="tab.label">
            {{ isMobile ? $t(`${tab.label}`) : '' }}
            <v-icon>{{ tab.icon }}</v-icon>
        </v-tab>
    </v-tabs>
</template>

<script lang="ts">
    import {Vue, Component, VModel} from 'vue-facing-decorator'

    @Component
    export class MobileSearchPageTabs extends Vue {
        @VModel({default: 1}) mobileTabs

        defaultTabs = [
            {icon: 'mdi-format-list-checks', label: 'filters'},
            {icon: 'mdi-format-list-text', label: 'offers'},
            {icon: 'mdi-map-marker', label: 'map'},
        ]

        get tabs() {
            return this.defaultTabs
        }

        get isMobile() {
            return this.$breakpoint.smAndDown
        }
    }

    export default MobileSearchPageTabs
</script>
